module.exports = __webpack_public_path__ + "static/media/izolacja80.25bd41c1.svg";